// Named colour tokens for the Carry & Basis board — mirrors the Market
// Probabilities board's own chrome layer (see ../market-probabilities/chrome.ts)
// so the two boards read as siblings. Platform chrome (dilettaPanelSx, DILETTA_*)
// stays in exotics-shared; this is this board's own layer, kept separate
// (rather than importing cross-page) so each board's palette can drift
// independently without coupling unrelated page directories.

// TEXT ramp, brightest -> faintest.
export const TEXT_HEADING = '#eaf4fb'; // page-head title (brightest)
export const TEXT_PRIMARY = '#cfe0ee'; // headline figures
export const TEXT_SUBTLE = '#8aa0b4'; // secondary numeric column
export const TEXT_MUTED = '#7d93a8'; // column heads, tile/freshness label
export const TEXT_DIM = '#6f8499'; // muted annotations
export const TEXT_DISABLED = '#5a6f81'; // muted tile value
export const TEXT_GHOST = '#4d6072'; // deepest em-dash

// Hairline border / scrollbar family.
export const BORDER_SUBTLE = 'rgba(51,87,110,.30)';

// Tile background for footer tile rows.
export const TILE_BG = '#11212e';

// Banner ccy accent.
export const ACCENT_SOFT = '#7fb9d8';

// Sign colours for carry/basis figures — positive carry (contango) reads
// green, negative (backwardation) reads red, matching the platform-wide
// positive/negative convention (see Number's NumberColour).
export const POSITIVE = '#3fb950';
export const NEGATIVE = '#ff6b6b';
